$('#select_room').change(function(){
    let value = parseInt( $('#select_room').val() )
    $.ajax({
        url: https + "/select_room",
        method: "POST",
        data:{value:value,action:'select_room'},
        success:function(data){
            if(data != ""){
                $('#info_room').html(data[0])
                $('#room_modal').html(data[1])
            }
        }
    });
})

$('#select_restaurant').change(function(){
    let value = parseInt( $('#select_restaurant').val() )
    $.ajax({
        url: https + "/select_restaurant",
        method: "POST",
        data:{value:value,action:'select_restaurant'},
        success:function(data){
            if(data != ""){
                $('#info_restaurant').html(data[0])
            }
        }
    });
})

$('.click_restaurant').click(function(){
    let value = parseInt( this.id )
    $('.click_restaurant').removeClass('selected')
    $('.restaurant_'+value).addClass('selected')
    $.ajax({
        url: https + "/select_restaurant",
        method: "POST",
        data:{value:value,action:'select_restaurant'},
        success:function(data){
            if(data != ""){
                $('#info_restaurant').html(data[0])
                $('#restaurant_reserva_click').html(data[1])
            }
        }
    });
})

$('#select_event').change(function(){
    let value = parseInt( $('#select_event').val() )
    $.ajax({
        url: https + "/select_event",
        method: "POST",
        data:{value:value,action:'select_event'},
        success:function(data){
            if(data != ""){
                $('#info_event').html(data[0])
                $('#info_modalCapacity').html(data[1])
                $('#info_modalChar').html(data[2])
            }
        }
    });
})

$('.click_event').click(function(){
    let value = parseInt( this.id )
    
    $('#select_salones_ejecutivos').val("0")
    $('#select_salones_ejecutivos').removeClass('select_salones_ejecutivos_active')

    $('.click_event').removeClass('selected')
    $('.event_'+value).addClass('selected')
    $.ajax({
        url: https + "/select_event",
        method: "POST",
        data:{value:value,action:'select_event'},
        success:function(data){
            if(data != ""){
                $('#info_event').html(data[0])
                $('#info_modalCapacity').html(data[1])
                $('#info_modalChar').html(data[2])
            }
        }
    });
})

$('#select_salones_ejecutivos').change(function(){
    let value = parseInt( $('#select_salones_ejecutivos').val() )
    $('.click_event').removeClass('selected')
    if(value == 0){
        $('#select_salones_ejecutivos').removeClass('select_salones_ejecutivos_active')
        return false;
    }
    $('#select_salones_ejecutivos').addClass('select_salones_ejecutivos_active')
    $.ajax({
        url: https + "/select_event",
        method: "POST",
        data:{value:value,action:'select_event'},
        success:function(data){
            if(data != ""){
                $('#info_event').html(data[0])
                $('#info_modalCapacity').html(data[1])
                $('#info_modalChar').html(data[2])
            }
        }
    });
})